import React from 'react';
import { List, Datagrid, TextField, DateField, EditButton, FunctionField } from 'react-admin';

const CrosswordsList = (props) => (
  <List {...props} sort={{ field: 'created_at', order: 'DESC' }}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="status" />
      <FunctionField label="Items Count" render={(record) => (record.items ? record.items.length : 0)} />
      <DateField source="created_at" showTime />
      <EditButton />
    </Datagrid>
  </List>
);

export default CrosswordsList;
